import { IIconProps } from 'src/interfaces/Icon';

const SubtitleIconMedium = ({ width = 22, height = 18, color = '#fff', ...props }: IIconProps) => (
  <svg
    data-testid='subtitle-icon-medium'
    width={width}
    height={height}
    viewBox='0 0 22 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M0 2.5C0 1.11929 1.11929 0 2.5 0H19.5C20.8807 0 22 1.11929 22 2.5V15.5C22 16.8807 20.8807 18 19.5 18H2.5C1.11929 18 0 16.8807 0 15.5V2.5ZM2.5 1C1.67157 1 1 1.67157 1 2.5V15.5C1 16.3284 1.67157 17 2.5 17H19.5C20.3284 17 21 16.3284 21 15.5V2.5C21 1.67157 20.3284 1 19.5 1H2.5ZM3 10.5C3 10.2239 3.22386 10 3.5 10H8.5C8.77614 10 9 10.2239 9 10.5C9 10.7761 8.77614 11 8.5 11H3.5C3.22386 11 3 10.7761 3 10.5ZM10 10.5C10 10.2239 10.2239 10 10.5 10H18.5C18.7761 10 19 10.2239 19 10.5C19 10.7761 18.7761 11 18.5 11H10.5C10.2239 11 10 10.7761 10 10.5ZM4 13.5C4 13.2239 4.22386 13 4.5 13H11.5C11.7761 13 12 13.2239 12 13.5C12 13.7761 11.7761 14 11.5 14H4.5C4.22386 14 4 13.7761 4 13.5ZM13 13.5C13 13.2239 13.2239 13 13.5 13H17.5C17.7761 13 18 13.2239 18 13.5C18 13.7761 17.7761 14 17.5 14H13.5C13.2239 14 13 13.7761 13 13.5Z'
      fill={color}
    />
  </svg>
);
export default SubtitleIconMedium;
